import React, { createContext, useState, useEffect } from "react";
import request from "../Helpers/API";

export const NotificationContext = createContext();

export const PRIORITY = {
  CRITICAL: 1,
  HIGH: 2,
  NORMAL: 3,
  LOW: 4,
};

const STORAGE_KEY = "hd_pending_notification";

const leerPendiente = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const guardarPendiente = (data) => {
  try {
    if (data) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (error) {
    // almacenamiento no disponible, se ignora
  }
};

export const NotificationProvider = ({ children }) => {
  const [queue, setQueue] = useState(() => {
    const pendiente = leerPendiente();
    return pendiente ? [pendiente] : [];
  });
  const [activeNotification, setActiveNotification] = useState(() => leerPendiente());
  // true mientras la notificación no ha sido atendida (chat respondido)
  const [atendiendo, setAtendiendo] = useState(false);

  const cargarModuloUsuario = async () => {
    try {
      const result = await request.get(`Mensajeria/GetRolMensajeria`);

      const rol = result?.idrol || result?.rol || result;

      const moduloAsignado =
        ["MESP", "MERP", "MEUP"].includes(rol)
          ? "POSVENTA"
          : ["MESC", "MERC", "MEUC"].includes(rol)
            ? "COBRANZA"
            : null;

      return moduloAsignado;
    } catch (error) {
      console.error("Error cargando módulo:", error);
      return null;
    }
  };

  // agregar nueva alerta
  const addNotification = (notification) => {
    const newNotification = {
      id: Date.now(),
      priority: PRIORITY.NORMAL,
      ...notification,
    };

    setQueue((prev) => {
      const updated = [...prev, newNotification];

      // ordenar por prioridad
      updated.sort((a, b) => a.priority - b.priority);

      return updated;
    });
  };

  // activar siguiente alerta
  useEffect(() => {
    if (!activeNotification && queue.length > 0) {
      setActiveNotification(queue[0]);
    }
  }, [queue, activeNotification]);

  // persistir la notificación activa para que sobreviva a un recargo de página
  useEffect(() => {
    guardarPendiente(activeNotification);
  }, [activeNotification]);

  // marcar que el usuario ya dio "Atender" (abrió el chat) — se mantiene bloqueado
  const marcarAtendiendo = () => {
    setAtendiendo(true);
  };

  // resolver alerta actual: solo se debe llamar cuando ya se respondió el chat
  const resolveNotification = () => {
    setAtendiendo(false);
    setQueue((prev) => prev.slice(1));
    setActiveNotification(null);
  };

  // limpiar todas
  const clearNotifications = () => {
    setAtendiendo(false);
    setQueue([]);
    setActiveNotification(null);
  };

  return (
    <NotificationContext.Provider
      value={{
        addNotification,
        activeNotification,
        resolveNotification,
        clearNotifications,
        queue,
        cargarModuloUsuario,
        atendiendo,
        marcarAtendiendo,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
